<template>
	<div class="side-nav-wrap">
		<div class="side-nav-brand" :class="{ 'is-collapse': collapse }" @click="goHome" title="返回首页">
			<img class="side-nav-logo" :src="logoUrl" alt="美铭科技" />
			<span class="side-nav-title" v-show="!collapse">美铭·服务平台</span>
		</div>
		<el-menu
		router
			unique-opened="true"
		      :default-active="activeIndex"
		      :collapse="collapse"
		      class="el-menu side-nav-menu"
		      @open="handleOpen"
		      @close="handleClose"
		      background-color="#2f3e4e"
		      text-color="#fff"
		      active-text-color="#409EFF">
		      <el-submenu index="1" v-if="$hasPermission('A1')">
		        <template slot="title">
		          <i class="el-icon-s-order"></i>
		          <span>业务办理</span>
		        </template>
				<el-menu-item v-if="$hasPermission('A103')" index="/business/photoInfo">拍照信息管理</el-menu-item>
				<el-menu-item v-if="$hasPermission('A104')" index="/business/paysInfo">缴费信息管理</el-menu-item>
				<el-menu-item v-if="$hasPermission('A104')" index="/business/printRecords">打印记录</el-menu-item>
				<el-menu-item v-if="$hasPermission('A105')" index="/business/refund">退款记录</el-menu-item>
		      </el-submenu>
		      <el-submenu index="2" v-if="$hasPermission('A2')">
		        <template slot="title">
		          <i class="el-icon-s-data"></i>
		          <span>统计报表</span>
		        </template>
		        <el-menu-item v-if="$hasPermission('A201')" index="/form/number">时间段统计</el-menu-item>
		        <el-menu-item v-if="$hasPermission('A202')" index="/form/day">每日统计</el-menu-item>
				<el-menu-item v-if="$hasPermission('A203')" index="/form/month">每月统计</el-menu-item>
				<el-menu-item v-if="$hasPermission('A204')" index="/form/detail">设备统计</el-menu-item>
		      </el-submenu>
		    </el-menu>
	</div>
</template>

<script>
	import logoUrl from '../../assets/48x48.png';
	export default {
	props: {
		collapse: {
			type: Boolean,
			default: false
		}
	},
	data(){
		return{
			activeIndex:'',
			logoUrl,
		}
	},
	  name: 'menu',
	  methods: {
		  handleOpen(){
			  
		  },
		  handleClose(){
			  
		  },
		  goHome() {
			this.$router.push({ path: '/home' });
			this.activeIndex = '';
		  }
	    },
		created() {
		    const currentRoute = this.$route.path;
			if (currentRoute === '/home') {
				this.activeIndex = '';
			}else{
				this.activeIndex = currentRoute;
			}
		}
	}
</script>

<style>
	  .side-nav-wrap {
		display: flex;
		flex-direction: column;
		flex: 1 1 auto;
		min-height: 0;
		height: 100%;
	  }

	  .side-nav-brand {
		display: flex;
		align-items: center;
		gap: 10px;
		height: 56px;
		padding: 0 16px;
		box-sizing: border-box;
		cursor: pointer;
		background-color: #2f3e4e;
		border-bottom: 1px solid rgba(255, 255, 255, 0.08);
		flex-shrink: 0;
		user-select: none;
		transition: background-color 0.2s ease;
	  }

	  .side-nav-brand:hover {
		background-color: #364859;
	  }

	  .side-nav-brand.is-collapse {
		justify-content: center;
		padding: 0 8px;
	  }

	  .side-nav-logo {
		width: 32px;
		height: 32px;
		object-fit: contain;
		flex-shrink: 0;
		display: block;
	  }

	  .side-nav-title {
		color: #fff;
		font-size: 15px;
		font-weight: 600;
		letter-spacing: 1px;
		white-space: nowrap;
		overflow: hidden;
	  }

	  .el-menu-item{
		margin-left: 15px;
	  }

	  .side-nav-menu {
		flex: 1 1 auto;
		min-height: 0;
		overflow-y: auto;
		overflow-x: hidden;
		height: auto;
		max-height: none;
	  }

	  .side-nav-menu .el-submenu .el-menu.el-menu--inline {
		max-height: none !important;
	  }
	  
	  .side-nav-menu:not(.el-menu--collapse) {
		width: 200px;
	  }
</style>
